import React from "react";
// import { Dashboard } from "modules/dashboard";
// import { FileFiltersProvider } from "modules/files/providers/FileFilters";
import withAuthenticationRequired from "shared/hocs/with-authentication-required";
import withSideBar from "shared/hocs/with-side-bar";
import { ROUTES } from "config/routes";

const Page = function (): React.ReactElement {
  React.useEffect(() => {
    window.location.href = ROUTES.VIDEOS;
  }, []);

  return (
    // <FileFiltersProvider>
    //   <Dashboard />
    // </FileFiltersProvider>
    <></>
  );
};

export default withAuthenticationRequired(withSideBar(Page));
